<template>
  <img ref="placeholder" class="trustpilot trustpilot-placeholder" src="@/asset/img/trustpiliot-placeholder.webp" width="230" height="120" alt="trustpilot-placeholder">
  <div ref="widget" class="trustpilot trustpilot-widget" data-locale="en-US" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="5631fd040000ff000584e5fb" data-style-height="100px" data-style-width="170px" data-theme="dark" data-tags="SelectedReview" data-font-family="Open Sans">
    <a href="https://www.trustpilot.com/review/bitskins.com" rel="nofollow noopener noreferrer" target="_blank">Check our reviews on TrustPilot</a>
  </div>
</template>

<style scoped lang="scss">
.trustpilot-placeholder {
  z-index: 1;
}
</style>

<script setup>
import { onMounted, ref } from 'vue';

const widget = ref();
const placeholder = ref();

const load = () => {
  if (window.Trustpilot) {
    window.Trustpilot.loadFromElement(widget.value);

    setTimeout(() => {
      placeholder.value.remove();
    }, 1000);
  }
};

onMounted(() => {
  if (window.Trustpilot) {
    load();
  } else {
    const script = document.createElement('script');
    script.onload = load;
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    document.head.appendChild(script);
  }
});
</script>
